import { getOpenAiAdsPixelId, type OpenAiAdsApp } from "./pixel-ids";
import type { OpenAiAdsEventName, OpenAiAdsEventOptions, OpenAiAdsEventPayloads } from "./types";

/**
 * Initializes the OpenAI Ads pixel with the app's pixel ID, if the loader script has run.
 * Safe to call from anywhere client-side — no-ops on the server or before the loader has run.
 */
export const initOpenAiAdsPixel = (app: OpenAiAdsApp): void => {
  if (typeof window === "undefined" || !window.oaiq) {
    return;
  }

  window.oaiq("init", { pixelId: getOpenAiAdsPixelId(app) });
};

/**
 * Fires an OpenAI Ads conversion event via the oaiq pixel, if it has loaded.
 * Safe to call from anywhere client-side — no-ops on the server or before the pixel loads.
 */
export const trackOpenAiAdsConversion = <Event extends OpenAiAdsEventName>(
  event: Event,
  payload: OpenAiAdsEventPayloads[Event],
  options?: OpenAiAdsEventOptions<Event>,
): void => {
  if (typeof window === "undefined" || !window.oaiq) {
    return;
  }

  window.oaiq("measure", event, payload, options);
};

